import { render, staticRenderFns } from "./TeacherPage.vue?vue&type=template&id=784ce414"
import script from "./TeacherPage.vue?vue&type=script&lang=ts"
export * from "./TeacherPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports